/**
 * 初始化pv/uv埋点
 *
 * @param erp
 * @param key
 */
function report(erp: string, key: string) {
  const ja = document.createElement('script');
  ja.type = 'text/javascript';
  ja.text = `
            var jaq = jaq || [];
            jaq.push(['account', 'JA2020_1222916']); // 站点编号
            jaq.push(['domain', 'yx.jd.com']); // 站点域名
            jaq.push(['erp_account', '${erp}']);
            jaq.push(['extParams', '${key}']);
            (function() {
                var ja = document.createElement('script');
                ja.type = 'text/javascript';
                ja.async = true;
                ja.src = 'https://wl.jd.com/joya.js';
                var s = document.getElementsByTagName('script')[0];
                s.parentNode.insertBefore(ja, s);
            })();
        `;
  const body = document.getElementsByTagName('body')[0];
  body.appendChild(ja);
}

/**
 * 手动上报埋点
 *
 * @param a
 * @param b
 * @param c
 * @param d
 * @param e
 * @param f
 */
function reportExp(a: string, b: string, c: string, d: string, e: string, f: string) {
  expLogJSON(a, b, c, d, e, f);
}

/**
 * 上报埋点
 *
 * @param a
 * @param b
 * @param c
 * @param d
 * @param e
 * @param f
 */
function expLogJSON(a: string, b: string, c: string, d: string, e: string, f: string) {
  proxyReport('expLogJSON', a, b, c, d, e, f);
}

let queue: any = [];

/**
 * 等待埋点文件加载完成
 */
function awaitScriptLoad() {
  const scriptDom = document.getElementById('logscripts');

  if (!scriptDom) return;

  scriptDom.addEventListener('load', clearQueue);
}

/**
 * 将队列中的埋点全都上报
 */
function clearQueue() {
  if (!queue) return;

  queue.forEach((item: any) => {
    (<any>window)[item.key](...item.value);
  });

  queue = [];
}

/**
 * 埋点代理
 *
 * @param method
 * @param a
 * @param b
 * @param c
 * @param d
 * @param e
 * @param f
 */
const proxyReport = function (method: any, a: string, b: string, c: string, d: string, e: string, f: string) {
  const args = Array.from(arguments).slice(1);
  if (!window[method]) {
    queue.push({
      key: method,
      value: args,
    });
  } else {
    (<any>window)[method](a, b, c, d, e, f);
  }
};

const timeLog = function (args: string[], time: number, once: boolean = false) {
  let a: any;

  const start = function () {
    (window as any).log(...args);
    if (once) {
      return;
    }
    a = window.setTimeout(start, time);
  };
  a = setTimeout(start, time);

  return () => {
    clearTimeout(a);
  };
};

export { awaitScriptLoad, reportExp, expLogJSON, report, timeLog };
